import * as React from 'react';
import { FormattedCurrency } from '../common/FormattedCurrency';
import DetailsCard from '../common/DetailsCard';
import LabeledValue from '../common/LabeledValue';
import strings from './strings';
import { buildClassString } from '../../StringUtils';
import { BenefitsChart } from '../../BenefitsChart';
import './style/index.scss';
export const TotalCashCompensationCard = (props) => {
    const { currency, totalCashCompensation, currencyFormatter, className, benefitsChartHeight, totalCashCompensationList, companyContributionsList, uncalculatedBenefitsList, hideBenefitsChart } = props;
    let contributionsTotal = 0;
    if (companyContributionsList) {
        contributionsTotal = companyContributionsList.reduce((prevValue, currentValue) => (prevValue + Number(currentValue.value)), 0);
    }
    const totalCashCardClassName = buildClassString({
        'tcc-card': true,
        [className]: !!className
    });
    return (React.createElement(DetailsCard, { className: totalCashCardClassName, title: strings.cardTitle },
        React.createElement(LabeledValue, { label: React.createElement("div", null, strings.description), value: totalCashCompensation ?
                React.createElement(FormattedCurrency, { val: totalCashCompensation + contributionsTotal, currency: currency, formatFunc: currencyFormatter, sensitiveValue: true }) :
                React.createElement("span", null, strings.notApplicable) }),
        !hideBenefitsChart && React.createElement(BenefitsChart, { totalCashCompensation: totalCashCompensationList || [], companyContributions: companyContributionsList || [], uncalculatedBenefits: uncalculatedBenefitsList || [], currency: currency, currencyFormatter: currencyFormatter, height: benefitsChartHeight })));
};
export default TotalCashCompensationCard;
